// Mock data for HighReach Apps Landing Page

export const siteConfig = {
  name: "HighReach Apps",
  tagline: "We Built a Website & Client Portal for Your Business – Free!",
  logoLight: "https://customer-assets.emergentagent.com/job_ac7776ea-3a95-4731-a773-a0a45df5cd45/artifacts/tf77ele4_HighReach%20Apps%20Logo%20White%20Orange%2C%20Green%20%26%20White.png",
  logoDark: "https://customer-assets.emergentagent.com/job_ac7776ea-3a95-4731-a773-a0a45df5cd45/artifacts/akcbfrke_HighReach%20Apps%20Logo%20Black%20Orange%2C%20Green%20%26%20White.png",
  phone: "+44 123 456 7890",
  email: "hello@highreachapps.com",
  bookingLink: "#book-call"
};

export const heroContent = {
  title: "We Built a Website & Client Portal for Your Business – Free!",
  subtitle: "You've seen the website and app we built for you. You're now in the right place to take the next step.",
  description: "We build real websites and client portals for hair & beauty businesses so owners can see what's possible before committing to anything.",
  highlights: [
    "No setup fees.",
    "No obligation.",
    "Just £30 per month for hosting if you decide to go live."
  ],
  ctaText: "Book a Free Call",
  secondaryCtaText: "Learn More"
};

export const whyYouSeeingThis = {
  title: "Why You're Seeing This",
  content: "We work with hair and beauty businesses that already value online bookings. Instead of asking you to imagine a better website or system, we build it first – tailored specifically to your business.",
  features: [
    "A fully branded website",
    "Online booking",
    "A client portal for managing appointments",
    "A mobile-friendly experience designed for your clients"
  ],
  note: "This page explains who we are, what's included, how we can tailor things to your taste, and what happens next if you choose to move forward."
};

export const whatYouveBeenSent = {
  title: "What You've Been Sent",
  intro: "The preview link you received shows a website and portal built specifically as an example for your business.",
  includes: [
    { title: "Custom-designed website", description: "Not a template demo" },
    { title: "Booking connected", description: "To a powerful backend" },
    { title: "Client-friendly design", description: "For mobile and desktop" },
    { title: "SEO-ready pages", description: "Designed to work for your business" }
  ],
  note: "If you'd like to view it again, simply use the same preview link we sent you by email."
};

export const startingPoint = {
  title: "A Starting Point – Not a Final Design",
  content: "What you've been sent is a bespoke starting point, built specifically for your business.",
  description: "If you'd like to adjust things – colours, layout, wording, images, or structure – we can tailor it further to better match your taste before going live.",
  highlight: "Nothing is locked in at this stage."
};

export const pricing = {
  title: "The Offer",
  intro: "We build your website and client portal completely free.",
  mainPrice: {
    amount: "£30",
    period: "per month",
    includes: [
      "One website",
      "One user account"
    ]
  },
  additionalUsers: {
    price: "£10",
    note: "per month each",
    description: "Additional users are typically for staff access or shared management – only add them if you need them."
  },
  benefits: [
    "No contracts",
    "No build fees",
    "No obligation"
  ],
  footer: "You only pay once the site is live and being used."
};

export const whyWeDoItThisWay = {
  title: "Why We Do It This Way",
  mostPlatforms: {
    title: "Most platforms:",
    items: [
      "Charge to build your website",
      "Charge monthly to host it",
      "Keep your reviews and SEO benefits on their platform",
      "Show other salons and suppliers next to your business"
    ]
  },
  ourApproach: {
    title: "We believe:",
    items: [
      "Your website should be your asset",
      "Your SEO should benefit your business",
      "Your clients shouldn't be distracted by competitors",
      "You should be able to see the value before paying anything"
    ]
  },
  conclusion: "So we flipped the script."
};

export const whatHappensNextYes = {
  title: "What Happens If You Say Yes",
  intro: "If you decide to move forward:",
  steps: [
    "We confirm a few details (branding, preferences, domain)",
    "We apply any final tweaks to make it feel even more like your business",
    "We connect everything to your live booking setup",
    "We get you live on your own website and client portal",
    "We provide ongoing training and support so you're confident using the platform"
  ],
  pricing: {
    hosting: "Hosting starts at £30 per month",
    includes: "(includes one website and one user, additional users are £10 per month each)",
    clients: "Unlimited clients can book and use the platform at no additional cost"
  },
  conclusion: "That's It!"
};

export const notReady = {
  title: "If You're Not Ready",
  intro: "No problem.",
  points: [
    "No pressure",
    "No obligation",
    "No follow-ups you don't want"
  ],
  note: "If you decide not to move forward, the preview website and portal will simply be removed after 14 days.",
  footer: "Nothing else changes."
};

export const optionalUpgrades = {
  title: "Optional Upgrades (Only If Useful)",
  intro: "Your setup already includes the essentials to run bookings smoothly.",
  standard: {
    title: "Included as standard:",
    items: [
      "Automated booking confirmations and reminders",
      "Online payments and deposits"
    ]
  },
  extras: {
    title: "Optional extras (only if you want them):",
    items: [
      "Loyalty or membership programmes",
      "Marketing tools",
      "Advanced reporting"
    ]
  },
  note: "These are optional and only added if they genuinely support how you want to run and grow your business."
};

export const finalCTA = {
  title: "What Would You Like to Do Next?",
  options: [
    {
      title: "Go Back to Your Website Preview",
      description: "Please use the preview link we sent you by email.",
      type: "secondary"
    },
    {
      title: "Book a Free, No-Obligation Call",
      description: "Ask questions, see how it works, and decide if it's right for you.",
      type: "primary"
    }
  ],
  tagline: "Built first. Paid only if you use it.",
  subTagline: "A better setup – without the risk."
};

export const images = {
  salonInterior: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzY4OTUwMzYzfDA&ixlib=rb-4.1.0&q=85&w=800",
  hairstylist: "https://images.unsplash.com/photo-1761373564177-8505a38c91f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzY4OTUwMzYzfDA&ixlib=rb-4.1.0&q=85&w=800",
  salonService: "https://images.pexels.com/photos/3736288/pexels-photo-3736288.jpeg?w=800",
  mobileApp: "https://images.unsplash.com/photo-1734070175532-651422f12471?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxib29raW5nJTIwYXBwfGVufDB8fHx8MTc2ODk1MDM2OHww&ixlib=rb-4.1.0&q=85&w=800",
  dashboard: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHx3ZWJzaXRlJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc2ODk1MDM3M3ww&ixlib=rb-4.1.0&q=85&w=800"
};
